export const memberships = [
    {
        id: '148599',
        title:'Monthly Membership',
        discount:0,
        renewAtDiscountedRate: true,
        duration:['monthly'],
        enabled:true,
        training:false,
        ends:1
    },
    {
        id: '148600',
        title:'AI for HR Hub Annual Membership',
        discount:0,
        renewAtDiscountedRate: true,
        duration:['annual'],
        enabled:true,
        training:false,
        ends:12
    },
   
    {
        id: '148602',
        title:'AI for HR Deep-Dive and 2 Year Access to AI for HR Hub',
        discount:100,
        renewalRate: 747,
        renewAtDiscountedRate: false,
        duration:['annual'],
        enabled:true,
        training:true,
        ends:24
    },
    {
        id: '148598',
        title:'AI for HR Deep-Dive and 2 Year Access to AI for HR Hub',
        discount:100,
        renewAtDiscountedRate: false,
        duration:['annual'],
        enabled:true,
        training:true,
        ends:24
    },
  
    {
        id: '148601',
        title:'Pryor Trainer Access',
        discount:0,
        renewAtDiscountedRate: true,
        duration:['monthly'],
        enabled:true,
        training:true,
        renewalRate: 10,
        ends:1
    },
    {
        id: '148603',
        title:'AI for HR Deep-Dive and 2 Year Access to AI for HR Hub',
        discount:0,
        renewalRate: 747,
        renewAtDiscountedRate: true,
        duration:['annual'],
        enabled:true,
        training:true,
        ends:24
    },
    {
        id: '148604',
        title:'AI for Business Hub 1 Year Access',
        discount:0,
        renewalRate: 747,
        renewAtDiscountedRate: true,
        duration:['annual'],
        enabled:true,
        training:true,
        ends:12
    },
    
]